// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import styled, { css } from "styled-components";

export const styledBox = css`
    padding: 16px;
    background: ${getColor("common.white")};
    border: 1px solid ${getColor("common.border")};
    border-radius: 2px;
`;

const StyledBox = styled.div<InjectableCss>`
    ${styledBox}
    ${injectCss}
`;

export default StyledBox;
